<style>
.slick_top{
  margin: 0px 25px 0px 25px ;
}
.slick_top a{
  text-decoration:none;color: #4f4f4f;
}
.slick_item{
  margin: 10px 15px;
  outline: none;
}
.slick_item a{
  text-decoration:none;
  outline: none;
}
.slick-prev::before, .slick-next::before {
  color: #4f4f4f;
}
.content {
    font-family: 微軟正黑體;
    background-color: rgb(255, 255, 255);
    position: -webkit-sticky; /* Safari */
    position: sticky;
    top: 0;
    width: 100%;
    z-index: 1;
}
</style>

<template>
    <div class="content">
        <div class="slick_top_hov">
            <slick
                ref="slick"
                :options="slickOptions"
                class="slick_top"
                >
                <div class="slick_item">
                    <div class="text-center" style="width:80px;">
                        <router-link to="/product/hotel" style="text-decoration:none;">
                            <i class="fas fa-hotel fa-3x"></i>
                            <div class="mt-2 icon_text_visible">
                                <b>飯店PMS</b>
                            </div>
                        </router-link>
                    </div>
                </div>
                <div class="slick_item">
                    <div class="text-center" style="width:80px;">
                        <router-link to="/product/pos" style="text-decoration:none;">
                            <i class="fas fa-utensils fa-3x"></i>
                            <div class="mt-2 icon_text_visible">
                                <b>餐廳POS</b>
                            </div>
                        </router-link>
                    </div>
                </div>
                <div class="slick_item">
                    <div class="text-center" style="width:80px;">
                        <router-link to="/product/purchase" style="text-decoration:none;">
                            <i class="fas fa-shopping-cart fa-3x"></i>
                            <div class="mt-2 icon_text_visible">
                                <b>採購庫存</b>
                            </div>
                        </router-link>
                    </div>
                </div>
                <div class="slick_item">
                    <div class="text-center" style="width:80px;">
                        <router-link to="/product/booking" style="text-decoration:none;">
                            <i class="fas fa-calendar-alt fa-3x"></i>
                            <div class="mt-2 icon_text_visible">
                                <b>訂席系統</b>
                            </div>
                        </router-link>
                    </div>
                </div>

                <div class="slick_item">
                    <div class="text-center" style="width:80px;">
                        <router-link to="/product/member" style="text-decoration:none;">
                            <i class="fas fa-user-circle fa-3x"></i>
                            <div class="mt-2 icon_text_visible">
                                <b>會員管理</b>
                            </div>
                        </router-link>
                    </div>
                </div>
                <div class="slick_item">
                    <div class="text-center" style="width:80px;">
                        <router-link to="/product/humanresource" style="text-decoration:none;">
                            <i class="fas fa-users fa-3x"></i>
                            <div class="mt-2 icon_text_visible">
                                <b>人資管理</b>
                            </div>
                        </router-link>
                    </div>
                </div>
                <div class="slick_item">
                    <div class="text-center" style="width:80px;">
                        <router-link to="/product/finance" style="text-decoration:none;">
                            <i class="fas fa-hand-holding-usd fa-3x"></i>
                            <div class="mt-2 icon_text_visible">
                                <b>財務管理</b>
                            </div>
                        </router-link>
                    </div>
                </div>
                <div class="slick_item">
                    <div class="text-center" style="width:80px;">
                        <router-link to="/product/fix" style="text-decoration:none;">
                            <i class="fas fa-wrench fa-3x"></i>
                            <div class="mt-2 icon_text_visible">
                                <b>工程維修</b>
                            </div>
                        </router-link>
                    </div>
                </div>
                <div class="slick_item">
                    <div class="text-center" style="width:80px;">
                        <router-link to="/product/securities" style="text-decoration:none;">
                            <i class="fas fa-ticket-alt fa-3x"></i>
                            <div class="mt-2 icon_text_visible">
                                <b>票券管理</b>
                            </div>
                        </router-link>
                    </div>
                </div>
                <div class="slick_item">
                    <div class="text-center" style="width:80px;">
                        <router-link to="/product/combine" style="text-decoration:none;">
                            <i class="fas fa-cogs fa-3x"></i>
                            <div class="mt-2 icon_text_visible">
                                <b>整合管理</b>
                            </div>
                        </router-link>
                    </div>
                </div>
                <div class="slick_item">
                    <div class="text-center" style="width:80px;">
                        <router-link to="/product/phone" style="text-decoration:none;">
                            <i class="fas fa-mobile-alt fa-3x"></i>
                            <div class="mt-2 icon_text_visible">
                                <b>行動裝置</b>
                            </div>
                        </router-link>
                    </div>
                </div>
                <div class="slick_item">
                    <div class="text-center" style="width:80px;">
                        <router-link to="/product/sale" style="text-decoration:none;">
                            <i class="fas fa-dolly-flatbed fa-3x"></i>
                            <div class="mt-2 icon_text_visible">
                                <b>商品銷售</b>
                            </div>
                        </router-link>
                    </div>
                </div>
            </slick>
        </div>
    </div>
</template>
<script>

export default {
    data(){
        return{
            slickOptions:{
                arrows: true,
                dots: false,
                infinite: false,
                slidesToShow: 12,
                slidesToScroll: 1,
                responsive: [{
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 6,
                        slidesToScroll: 6
                    }
                    },{
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                    },{
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }}
                ]
            },
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/product/slick_top.vue